import type { ReactNode } from 'react';

interface SirhPageHeaderProps {
  title: string;
  /** Une phrase, pas un paragraphe : elle dit ce que l'écran permet de faire. */
  subtitle?: string;
  actions?: ReactNode;
}

/**
 * En-tête commun aux écrans SIRH.
 *
 * Il reprend l'en-tête des écrans voisins (titre en `text-2xl font-semibold
 * text-neutral-900`, action à droite) plutôt que d'inventer un style local, et
 * il tient sur une seule ligne : rien ne doit repousser le contenu utile vers
 * le bas de l'écran.
 */
export function SirhPageHeader({ title, subtitle, actions }: SirhPageHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold text-neutral-900">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-neutral-500">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
